import { service } from '../../../../helpers/http'

export const ActionGetTeacherIndicators = ({ dispatch }, payload) => { 
    return service({
        module: 'domainTeacherIndicator',
        action: 'getTeacherIndicators',
        payload: payload
    })
}

export const ActionPostTeacherIndicator = ({ dispatch }, payload) => {

    return service({
        module: 'domainTeacherIndicator',
        action: 'postTeacherIndicator',
        payload: payload
    })
    
}

export const ActionPutTeacherIndicator = ({ dispatch }, payload) => {

    return service({
        module: 'domainTeacherIndicator',
        action: 'putTeacherIndicator',
        payload: payload
    })
    
}

export const ActionDeleteTeacherIndicator = ({ dispatch }, payload) => {

    return service({
        module: 'domainTeacherIndicator',
        action: 'deleteTeacherIndicator',
        payload: payload
    })
    
}

export const ActionIndexVariationStatuses = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'indexVariationStatuses',
        payload: payload
    })
}

export const ActionSummaryByWorkRegime = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'summaryByWorkRegime',
        payload: payload
    })
}

export const ActionSummaryByTitling = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'summaryByTitling',
        payload: payload
    })
}

export const ActionSummaryByTitlingDetail = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'summaryByTitlingDetail',
        payload: payload
    })
}

export const ActionSummaryActiveTeachers = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'summaryActiveTeachers',
        payload: payload
    })
}

export const ActionActiveTeachersList = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'activeTeachersList',
        payload: payload
    })
}

export const ActionSummaryByCourse = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'summaryByCourse',
        payload: payload
    })
}

export const ActionSummaryChByRegime = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'summaryChByRegime',
        payload: payload
    })
}

export const ActionWorkRegimeHistory = ({ dispatch }, payload) => {
    return service({
        module: 'domainTeacherIndicator',
        action: 'workRegimeHistory',
        payload: payload
    })
}
